/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { t as throttle_1 } from '../_chunks/dep-b0a01ce1.js';
import { useState, useRef } from 'react';
import { useTreeDraggableContext } from './TreeDraggableContext.js';
import { usePersistFn } from '../_util/usePersistFn.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-77a54538.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/createHookContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useDraggable(props) {
  var nodeRef = props.nodeRef,
    node = props.node;
  var _useTreeDraggableCont = useTreeDraggableContext(),
    onDragStart = _useTreeDraggableCont.onDragStart,
    onDragEnd = _useTreeDraggableCont.onDragEnd,
    onDragLeave = _useTreeDraggableCont.onDragLeave,
    onDragOver = _useTreeDraggableCont.onDragOver,
    onDrop = _useTreeDraggableCont.onDrop;
  var _useState = useState({
      isDragOver: false,
      isDragging: false,
      dropPosition: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setPartialState = usePersistFn(function (newState) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), newState);
    });
  });
  var updateDropPosition = useRef(throttle_1(function (e) {
    if (!nodeRef.current) return;
    var rect = nodeRef.current.getBoundingClientRect();
    var offsetY = window.pageYOffset + rect.top;
    var pageY = e.pageY;
    var gapHeight = rect.height / 4;
    var diff = pageY - offsetY;
    if (diff < gapHeight) {
      setPartialState({
        dropPosition: -1
      });
    } else if (diff < rect.height - gapHeight) {
      setPartialState({
        dropPosition: 0
      });
    } else {
      setPartialState({
        dropPosition: 1
      });
    }
  })).current;
  var setDragStatus = function setDragStatus(status, e) {
    switch (status) {
      case "dragStart":
        setPartialState({
          isDragging: true,
          dropPosition: 0
        });
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart({
          node: node,
          e: e
        });
        break;
      case "dragEnd":
        setPartialState({
          isDragging: false,
          isDragOver: false,
          dropPosition: 0
        });
        updateDropPosition.cancel();
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd({
          node: node,
          e: e
        });
        break;
      case "dragOver":
        setPartialState({
          isDragOver: true
        });
        updateDropPosition(e);
        onDragOver === null || onDragOver === void 0 ? void 0 : onDragOver({
          node: node,
          e: e
        });
        break;
      case "dragLeave":
        setPartialState({
          isDragOver: false,
          dropPosition: 0
        });
        updateDropPosition.cancel();
        onDragLeave === null || onDragLeave === void 0 ? void 0 : onDragLeave({
          node: node,
          e: e
        });
        break;
      case "drop":
        onDrop === null || onDrop === void 0 ? void 0 : onDrop({
          node: node,
          dropPosition: state.dropPosition,
          e: e
        });
        setPartialState({
          isDragOver: false
        });
        updateDropPosition.cancel();
        break;
      default:
        break;
    }
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    setDragStatus: setDragStatus
  });
}

export { useDraggable as default };
//# sourceMappingURL=useDraggable.js.map
